(function WorkflowFindController() {
    'use strict';

    angular.module('Workflow')
        .controller('WorkflowFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'authExtend', 'workflowService', '$filter',
            function workflowController($scope, config, $state, $translate, errors, authExtend, workflowService, $filter) {

                $scope.workflows = [];

                $scope.showNoData = false;

                $scope.load = function () {
                    workflowService.get().then(function (result) {
                        $scope.workflows = result.value;
                        if ($scope.workflows.length > 0) {
                            $scope.workflows.forEach(function (wf) {
                                wf.documentName = $filter('filter')(wf.variables, { name: "nombreDocumento" })[0].value;
                                wf.documentVersion = $filter('filter')(wf.variables, { name: "versionDocumento" })[0].value;
                                wf.documentId = $filter('filter')(wf.variables, { name: "IdDocumento" })[0].value;
                            });
                        }

                        $scope.showNoData = $scope.workflows.length === 0;

                    }, function (error) {
                        errors.showError(error);
                    });
                }

                $scope.modify = function (wf) {
                    $state.go('workflow-modify', { id: wf.id });
                }

                $scope.docDetail = function (wf) {
                    $state.go('document-detail', { id: wf.documentId });
                }
                
                $scope.load();
            }
        ]);
})();